import { Card, Col, Layout, Row } from "antd";
import PublicHeader from "../../layout/publicLayout/header";
import MorningSkincareRoutine from "./morningSkincareRoutine";
import NightSkincareRoutine from "./nightSkincareRoutine";
import AdditionalSkincareNotes from "./additionalSkincareNotes";
import ThankYou from "./thankyou";
import QueryForm from "./queryForm";

interface HomeStoreProps {
  data?: any;
}

const HomeStoreComponent: React.FC<HomeStoreProps> = ({ data }: any) => {
  const skinProfile = data?.skin_profile;

  const capitalize: any = (s: any) => s?.charAt(0).toUpperCase() + s?.slice(1);
  return (
    <Layout style={{ background: "#f0f7ff" }}>
      <PublicHeader />
      <section className="home-store">
        <Row gutter={16}>
          <Col xs={24} md={12} lg={12}>
            <Card>
              <h3 className="title">
                Greetings {data?.customer_name}, Welcome!
              </h3>
              <p className="description">{data?.welcome_message}</p>
              <p className="helper-text">— Making Your Skincare Routine Easy</p>
              <p className="helper-text">Lots of ❤️ from Missing Skincare</p>
            </Card>
          </Col>
          <Col xs={24} md={12} lg={12}>
            <Card>
              <h3 className="title">Your Skin Profile</h3>
              <Row gutter={[0, 24]}>
                <Col xs={12} md={12} lg={8}>
                  <h3 className="ms-card-title">Date</h3>
                  <p className="ms-title-des">{skinProfile?.date}</p>
                </Col>
                <Col xs={12} md={12} lg={8}>
                  <h3 className="ms-card-title">Skincare Level</h3>
                  <p className="ms-title-des">
                    {capitalize(skinProfile?.skincare_level)}
                  </p>
                </Col>
                <Col xs={12} md={12} lg={8}>
                  <h3 className="ms-card-title">Skin Type</h3>
                  <p className="ms-title-des">
                    {capitalize(skinProfile?.skin_type)}
                  </p>
                </Col>
                <Col xs={12} md={12} lg={8}>
                  <h3 className="ms-card-title">Acne</h3>
                  <p className="ms-title-des">
                    {capitalize(skinProfile?.acne)}
                  </p>
                </Col>
                <Col xs={12} md={12} lg={8}>
                  <h3 className="ms-card-title">Skin Concerns</h3>
                  <p className="ms-title-des">{skinProfile?.skin_concerns}</p>
                </Col>
                <Col xs={12} md={12} lg={8}>
                  <h3 className="ms-card-title">Sensitivity</h3>
                  <p className="ms-title-des">
                    {capitalize(skinProfile?.sensitivity)}
                  </p>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        <MorningSkincareRoutine
          data={data?.morning}
          userName={data?.customer_name}
          capitalize={capitalize}
        />
        <NightSkincareRoutine
          data={data?.night}
          userName={data?.customer_name}
          capitalize={capitalize}
        />
        <AdditionalSkincareNotes data={data?.additional_notes} />
        <ThankYou
          data={data?.customer_type}
          userName={data?.customer_name}
          subscriptionStatus={data?.subscription_status}
        />
      </section>
    </Layout>
  );
};

export default HomeStoreComponent;
